import {
  Accordion as MantineAccordion,
  AccordionProps as MantineAccordionProps,
} from "@mantine/core"
import { FC } from "react"

import classes from "./Accordion.module.css"

export type AccordionProps = MantineAccordionProps

type AccordionComponent = FC<AccordionProps> & {
  Item: typeof MantineAccordion.Item
  Control: typeof MantineAccordion.Control
  Panel: typeof MantineAccordion.Panel
}

export const Accordion: AccordionComponent = ({
  children,
  variant = "default",
  ...props
}: AccordionProps) => {
  return (
    <MantineAccordion variant={variant} classNames={classes} {...props}>
      {children}
    </MantineAccordion>
  )
}

Accordion.Item = MantineAccordion.Item
Accordion.Control = MantineAccordion.Control
Accordion.Panel = MantineAccordion.Panel

export default Accordion
